function convertDate(epoch) {
    return epoch;
}

export default class DataStore {
    constructor(useCms) {
        this._useCms = useCms;

        this._exerciseUrlCms = 'https://nastaunik.eu/node.json?type=toolkit_item';        
        this._metadataUrl = 'https://nastaunik.eu/mediatoolkit/exercises.json';

        this._convertFromCms = (json) =>
            json.list.map((cmsExercise) => ({
                id: cmsExercise.nid,        
                date: convertDate(cmsExercise.created),        
                firstName: cmsExercise.field_author,
                lastName: "",        
                discipline_id: cmsExercise.field_discipline,
                ageRange: cmsExercise.field_age_group,        
                title: cmsExercise.title,
                competence: cmsExercise.field_competention, 
                requirements: cmsExercise.field_requirements,        
                length: cmsExercise.field_length,        
                methods: cmsExercise.field_methods,
                themes: cmsExercise.field_theme,
                summary: cmsExercise.body.summary,
                text: cmsExercise.field_html_body.value,
                tips: cmsExercise.field_suggestion,
                links: cmsExercise.field_links.map(link => ({ name: link, url: link})),
                popular: cmsExercise.field_popular
            }));

        this._fetchExerciseFromCms = async function() {
            let pageNumber = 0;
            let pageItems = [];
            let allItems = [];

            do {
                let response = await fetch(`${this._exerciseUrlCms}&page=${pageNumber++}`);
                if (response.ok) {
                    let json = await response.json();
                    pageItems = this._convertFromCms(json);
    
                    allItems = [...allItems, ...pageItems];
                }
                else 
                    pageItems = []
            }
            while (pageItems.length > 0)

            return allItems;
        };

        this.metadataJsonPromise = fetch(this._metadataUrl).then(response => response.json());
    }

    getExercises() {
        return this._fetchExerciseFromCms();
    }

    getDisciplines() {
        return this.metadataJsonPromise
            .then(json => json['all-disciplines'])

    }

    getCompetencies() {
        return this.metadataJsonPromise
            .then(json => json['all-competencies'])
    }

    getAgeGroups() {
        return this.metadataJsonPromise
            .then(json => json['all-age-groups'])
    }

    getThemes() {
        return this.metadataJsonPromise
            .then(json => json['all-themes'])
    }
}
